import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { map, toArray } from "@fxts/core"
import { pipe } from "@fxts/core"

import { profileId } from "@/app/(dashboard)/(sidebar)/api/config"
import { ApiErrorResponse, PageResult } from "@/clients/types"
import { CustomerModel } from "@/features/customers"

import {
  FetchCustomerApi,
  fetchCustomerApi,
  fetchCustomerListApi,
  FetchCustomerListApi,
} from "./apis"
import { toSelectCustomerModel } from "./select"

export const customerQueries = {
  _id: ["customers", profileId],
  customersWithPagination: (params: FetchCustomerListApi["Params"]) => {
    const { workspaceId, size, page, searchKeyword } = params
    return queryOptions<
      FetchCustomerListApi["Response"],
      ApiErrorResponse,
      PageResult<CustomerModel>
    >({
      queryKey: [
        ...customerQueries._id,
        "withPagination",
        workspaceId,
        size,
        page,
        searchKeyword,
      ],
      queryFn: () => {
        return fetchCustomerListApi(params)
      },
      placeholderData: keepPreviousData,
      select: res => {
        return {
          ...res,
          content: pipe(res.content, map(toSelectCustomerModel), toArray),
        }
      },
    })
  },
  customers: (params: FetchCustomerListApi["Params"]) => {
    const { workspaceId, size, page, searchKeyword } = params
    return queryOptions<
      FetchCustomerListApi["Response"],
      ApiErrorResponse,
      PageResult<CustomerModel>
    >({
      queryKey: [...customerQueries._id, workspaceId, size, page, searchKeyword],
      queryFn: () => {
        return fetchCustomerListApi(params)
      },
      select: res => {
        return {
          ...res,
          content: pipe(res.content, map(toSelectCustomerModel), toArray),
        }
      },
    })
  },
  customerBy: (params: FetchCustomerApi["Params"]) => {
    const { workspaceId, customerId } = params
    return queryOptions<
      FetchCustomerApi["Response"],
      ApiErrorResponse,
      CustomerModel
    >({
      queryKey: [...customerQueries._id, workspaceId, customerId],
      queryFn: () => {
        if (!customerId) {
          return Promise.reject({ message: "customerId is required" })
        }
        return fetchCustomerApi(params)
      },
      select: toSelectCustomerModel,
      enabled: !!customerId,
    })
  },
}
